/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventsviewcalendar2Inputs */

const en_eventsviewcalendar2 = /** @type {(inputs: Eventsviewcalendar2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar`)
};

const de_eventsviewcalendar2 = /** @type {(inputs: Eventsviewcalendar2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalender`)
};

/**
* | output |
* | --- |
* | "Calendar" |
*
* @param {Eventsviewcalendar2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventsviewcalendar2 = /** @type {((inputs?: Eventsviewcalendar2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventsviewcalendar2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventsviewcalendar2(inputs)
	return de_eventsviewcalendar2(inputs)
});
export { eventsviewcalendar2 as "eventsViewCalendar" }